import { render, staticRenderFns } from "./BuyerDataComponent.vue?vue&type=template&id=32dbb578&"
import script from "./BuyerDataComponent.vue?vue&type=script&lang=js&"
export * from "./BuyerDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports